<template>
  <div class="wrap_floor_details">
    <h3 class="floor_details_header"><span>ABOUT CLINIC</span></h3>
    <div class="floor_details">
      <div class="floor_detail" v-for="(detail, index) in details" :class="{}">
        <a :href="detail.link" :class="{unable : detail.link == ''}" target="_blank">
          <p class="floor_num">FLOOR {{5-index}}</p>
          <p class="clinic_name" v-html="detail.clinic_name"></p>
          <p class="clinic_expert" v-html="detail.expert"></p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloorDetails',
  props: {
    msg: String
  },
  data () {
    return {
      details: [
        {
          clinic_name: '河西クリニック',
          expert: '循環器内科・呼吸器内科・一般内科<br>リウマチ膠原病内科・アレルギー科<br>整形外科',
          link: 'http://www.kawanishi-clinic.com/'
        },
        {
          clinic_name: '2019年4月　開院予定',
          expert: '消化器内科・内視鏡内科・肝臓内科',
          link: ''
        },
        {
          clinic_name: '2019年9月　開院予定',
          expert: '泌尿器科・腎臓外科<br>ペインクリニック内科',
          link: ''
        },
        {
          clinic_name: 'しんかい眼科クリニック',
          expert: '眼科・コンタクトレンズ処方<br>日帰り白内障手術（手術室完備）',
          link: 'http://shinkai-eye.com'
        },
        {
          clinic_name: '総合受付',
          expert: '調剤薬局・カフェ・銀行ATM・売店',
          link: ''
        },
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrap_floor_details {
  margin-top: 36px;
  .floor_details_header {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: initial;
    height: initial;
    margin-bottom: 36px;
    background: none;
    span {
      display: inline-block;
      font-size: 12px;
      font-weight: bold;
      &:after {
        content: '';
        display: block;
        width: 80%;
        height: 2px;
        margin: 0 auto;
        background-color: #86C4C9;
      }
    }
  }
}
.floor_detail {
  @for $i from 1 through 5 {
    &:nth-child(#{$i}) {
      background-image: url('/assets/img/home/bg_floor_#{6 - $i}f.jpg');
    }
  }
  &:not(:last-child) {
    border-bottom: 1px solid #ffffff;
  }
  a {
    position: relative;
    display: block;
    min-height: 200px;
    padding: 33px 52px 0 32px;
    &.unable {
      user-select: none;
      pointer-events: none;
      &::after {
        display: none;
      }
    }
    &:after {
      position: absolute;
      top: 50%;
      right: 20px;
      content: '';
      display: block;
      width: 6px;
      height: 6px;
      margin-top: -3px;
      border-top: 2px solid #ffffff;
      border-right: 2px solid #ffffff;
      transform: rotate(45deg);
    }
  }
  .floor_num {
    margin-bottom: 5px;
    color: #ffffff;
    font-size: 10px;
  }
  .clinic_name {
    margin-bottom: 10px;
    color: #ffffff;
    font-size: 18px;
    line-height: 1.8;
    border-bottom: 2px solid #ffffff;
  }
  .clinic_expert {
    color: #ffffff;
    font-size: 12px;
    line-height: 1.7;
  }
}

</style>
